import PropTypes from "prop-types";

const isExternal = (url) => !url.startsWith("mailto:");

const SocialLinks = ({ profiles }) => {
  const visible = profiles.filter((profile) => profile.url);

  if (visible.length === 0) return null;

  // Ces liens n'affichent qu'une icône : sans nom accessible ils seraient
  // annoncés « lien » par un lecteur d'écran. La clé sert donc de repli.

  return (
    <ul className="bostami-parsonal-info-social-link mb-30">
      {visible.map((profile) => (
        <li key={profile.key}>
          <a
            href={profile.url}
            className={profile.brandClass}
            aria-label={profile.label || profile.key}
            title={profile.label || profile.key}
            {...(isExternal(profile.url)
              ? { target: "_blank", rel: "noreferrer noopener" }
              : {})}
          >
            <i className={profile.icon} aria-hidden="true" />
          </a>
        </li>
      ))}
    </ul>
  );
};

SocialLinks.propTypes = {
  profiles: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string,
      url: PropTypes.string.isRequired,
      brandClass: PropTypes.string.isRequired,
      icon: PropTypes.string,
    })
  ).isRequired,
};

export default SocialLinks;
